<template>
  <div class="container" id="navigation-container">
    <b-navbar toggleable="lg" fixed="top" id="nav-main">
      <b-navbar-brand href="#">
        <img src="@/assets/logo-small.png" alt="Fidelior logo" />
      </b-navbar-brand>
      <b-navbar-toggle target="nav-text-collapse"></b-navbar-toggle>
      <b-collapse id="nav-text-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="#/#">Home</b-nav-item>
          <b-nav-item href="#/#" @click="goto('about')">About</b-nav-item>
          <b-nav-item href="#/#" @click="goto('fees')">License</b-nav-item>
          <b-nav-item-dropdown text="Readings and Resources">
            <b-dropdown-item
              href="https://fidelior.net/wp-content/uploads/2019/12/Readings-on-the-pseudo-science-landscape-.pdf"
              target="_blank" class="text-wrap"
            >Read about the pseudo-science landscape (392 References / Last updated: 25 November 2019)</b-dropdown-item>
            <b-dropdown-item
              href="https://fidelior.net/wp-content/uploads/2019/12/Readings-on-predatory-conferences.pdf"
              target="_blank" class="text-wrap"
            >Read about predatory conferences (24 References / Last updated: 25 November 2019</b-dropdown-item>
            <b-dropdown-item
              href="http://flakyj.blogspot.com/"
              target="_blank" class="text-wrap"
            >Blogs on predatory publishing: Flaky academic journals</b-dropdown-item>
            <b-dropdown-item
              href="https://blog.cabells.com/"
              target="_blank" class="text-wrap"
            >Blogs on predatory publishing: Cabell’s blog ‘The Source’</b-dropdown-item>
            <b-dropdown-item
              href="https://scholarlykitchen.sspnet.org/"
              target="_blank" class="text-wrap"
            >Blogs on predatory publishing: Scholarly Kitchen</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item href="#/#" @click="goto('resources')">Resources</b-nav-item>
          <b-nav-item href="#/#" @click="goto('contact')">Contact</b-nav-item>
          <b-nav-item href="https://app.fidelior.net/login">Login</b-nav-item>
          <b-nav-item href="https://app.fidelior.net/register">Subscribe</b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item
            href="https://github.com/Fidelior/Fidelior"
            target="_blank"
            aria-label="GitHub"
          >
            <svg
              class="navbar-nav-svg"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 499.36"
              focusable="false"
              style="width: 20px; height: 20px;"
            >
              <title>GitHub</title>
              <path
                d="M256 0C114.64 0 0 114.61 0 256c0 113.09 73.34 209 175.08 242.9 12.8 2.35 17.47-5.56 17.47-12.34 0-6.08-.22-22.18-.35-43.54-71.2 15.49-86.2-34.34-86.2-34.34-11.64-29.57-28.42-37.45-28.42-37.45-23.27-15.84 1.73-15.55 1.73-15.55 25.69 1.81 39.21 26.38 39.21 26.38 22.84 39.12 59.92 27.82 74.5 21.27 2.33-16.54 8.94-27.82 16.25-34.22-56.84-6.43-116.6-28.43-116.6-126.49 0-27.95 10-50.8 26.35-68.69-2.63-6.48-11.42-32.5 2.51-67.75 0 0 21.49-6.88 70.4 26.24a242.65 242.65 0 0 1 128.18 0c48.87-33.13 70.33-26.24 70.33-26.24 14 35.25 5.18 61.27 2.55 67.75 16.41 17.9 26.31 40.75 26.31 68.69 0 98.35-59.85 120-116.88 126.32 9.19 7.9 17.38 23.53 17.38 47.41 0 34.22-.31 61.83-.31 70.23 0 6.85 4.61 14.81 17.6 12.31C438.72 464.97 512 369.08 512 256.02 512 114.62 397.37 0 256 0z"
                fill="currentColor"
                fill-rule="evenodd"
              />
            </svg>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  methods: {
    goto(refName) {
      var element = document.getElementById(refName);

      if (!element) {
        return;
      }

      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  }
};
</script>
